export default "__VITE_ASSET__ChebwxOV__"